import { createSlice } from "@reduxjs/toolkit";
//constants
import {
  layoutTypes,
  leftSidebarTypes,
  layoutModeTypes,
  layoutWidthTypes,
  layoutPositionTypes,
  topbarThemeTypes,
  leftsidbarSizeTypes,
  leftSidebarViewTypes,
  leftSidebarImageTypes,
  preloaderTypes,
  sidebarVisibilitytypes
} from "../../Components/constants/layout";

// Round PREF-1 — mode ("light" | "dark") of the user's saved theme.
// "app.theme" holds keys like "dark-midnight" / "light-sand" (see
// Components/Common/LightDark.js). Safe under blocked storage.
const readSavedThemeMode = () => {
  try {
    const v = window.localStorage.getItem("app.theme");
    if (v && v.startsWith("dark-")) return "dark";
  } catch (e) { /* storage blocked — default light */ }
  return "light";
};

export const initialState = {
  layoutType: layoutTypes.VERTICAL,
  // Phase Z3 — sidebar defaults to LIGHT to avoid the black-flash on refresh.
  // Previously DARK was the initial state; on every page load the sidebar
  // would render black until subsequent code flipped it to light.
  //
  // Round PREF-1 (2026) — theme-reset-on-refresh ROOT CAUSE FIX: the Layout
  // component dispatches these initial values on every mount, which was
  // stomping the user's saved dark theme back to light right after the
  // theme picker applied it. The initial mode (and matching sidebar) now
  // reads the persisted theme ("app.theme", written by the picker and
  // seeded from the per-user Preferences API at startup), so the very
  // first layout dispatch already carries the user's choice — no flash,
  // no reset. Falls back to the light defaults exactly as before.
  leftSidebarType: readSavedThemeMode() === "dark" ? leftSidebarTypes.DARK : leftSidebarTypes.LIGHT,
  layoutModeType: readSavedThemeMode() === "dark" ? layoutModeTypes.DARKMODE : layoutModeTypes.LIGHTMODE,
  layoutWidthType: layoutWidthTypes.FLUID,
  layoutPositionType: layoutPositionTypes.FIXED,
  topbarThemeType: topbarThemeTypes.LIGHT,
  leftsidbarSizeType: leftsidbarSizeTypes.DEFAULT,
  leftSidebarViewType: leftSidebarViewTypes.DEFAULT,
  leftSidebarImageType: leftSidebarImageTypes.NONE,
  preloader: preloaderTypes.ENABLE,
  sidebarVisibilitytype: sidebarVisibilitytypes.SHOW
};

const LayoutSlice = createSlice({
  name: 'LayoutSlice',
  initialState,
  reducers: {
    changeLayoutAction(state, action) {
      state.layoutType = action.payload;
    },
    changeLayoutModeAction(state, action) {
      state.layoutModeType = action.payload;
    },
    changeSidebarThemeAction(state, action) {
      state.leftSidebarType = action.payload;
    },
    changeLayoutWidthAction(state, action) {
      state.layoutWidthType = action.payload;
    },
    changeLayoutPositionAction(state, action) {
      state.layoutPositionType = action.payload;
    },
    changeTopbarThemeAction(state, action) {
      state.topbarThemeType = action.payload;
    },
    changeLeftsidebarSizeTypeAction(state, action) {
      state.leftsidbarSizeType = action.payload;
    },
    changeLeftsidebarViewTypeAction(state, action) {
      state.leftSidebarViewType = action.payload;
    },
    changeSidebarImageTypeAction(state, action) {
      state.leftSidebarImageType = action.payload;
    },
    changePreLoaderAction(state, action) {
      state.preloader = action.payload;
    },
    changeSidebarVisibilityAction(state, action) {
      state.sidebarVisibilitytype = action.payload;
    }
  }
});

export const {
  changeLayoutAction,
  changeLayoutModeAction,
  changeSidebarThemeAction,
  changeLayoutWidthAction,
  changeLayoutPositionAction,
  changeTopbarThemeAction,
  changeLeftsidebarSizeTypeAction,
  changeLeftsidebarViewTypeAction,
  changeSidebarImageTypeAction,
  changePreLoaderAction,
  changeSidebarVisibilityAction
} = LayoutSlice.actions;

export default LayoutSlice.reducer;